import { Component, Inject, OnInit } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogModule as MatDialogModule, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { GrowlerService } from '../../../shared/growler/growler.service';

export interface ConfirmWithSelectionDialogInput
{
    title: string;
    content: string;
    selectionLabel: string;
    selections?: {
        [key: string]: any;
        label: string;
    }[];
    btnContent: string;
    secondaryBtnContent?: string;
    selectionRequired: boolean;
    selectionRequiredSecondary?: boolean;
    useOutlineAppearance?: boolean;
    selectionWarning?: (selection: { id: number; label: string; }) => string;
}

export interface ConfirmWithSelectionDialogResult
{
    success: boolean;
    secondaryBtnClicked: boolean;
    selection: {
        [key: string]: any;
        label: string;
    };
}


@Component({
    selector: 'app-confirm-with-selection-dialog',
    templateUrl: './confirm-with-selection-dialog.component.html',
    standalone: true,
    imports: [
        SharedModule,
        MatDialogModule,
        MatInputModule,
        MatSelectModule,
    ],
})

export class ConfirmWithSelectionDialogComponent implements OnInit
{
    form: UntypedFormGroup = null;

    constructor(
            private _dialogRef: MatDialogRef<ConfirmWithSelectionDialogComponent>,
            private _formBuilder: UntypedFormBuilder,
            private _growler: GrowlerService,
            @Inject(MAT_DIALOG_DATA) public data: ConfirmWithSelectionDialogInput,
    ) {
    }

    ngOnInit(): void {
        this.form = this._formBuilder.group({
            selection: [
                null,
                this.data.selectionRequired ? [Validators.required] : [],
            ],
        });
    }

    closeAndConfirm(secondary: boolean = false) {
        if (secondary && this.data.hasOwnProperty('selectionRequiredSecondary') && !this.data.selectionRequiredSecondary) {
            this._dialogRef.close(<ConfirmWithSelectionDialogResult>{
                success: true,
                secondaryBtnClicked: true,
            });
            return;
        }
        if (this.form.invalid) {
            this._growler.error('Missing Reason', 'The reason is a required field.');
            return;
        }
        this._dialogRef.close(<ConfirmWithSelectionDialogResult>{
            success: true,
            secondaryBtnClicked: secondary,
            selection: this.form.get('selection').value,
        });
    }

}
